export default {
  configName: 'Configuration Name',
  configAmount: 'Configure Quota',
  update: 'Update',

  cancel: '取消',
  success: '成功',
  error: '失败',
  del: '删除',
  search: '搜索',
  detail: '详情',
  editor: '编辑',
  empty: '清空',
  emptyValue: '空值',
  add: '新增',
  export: '导出',
  hint: '提示',
  withdraw: '提现',
  review: 'review',
  pass: 'pass',
  reject: 'reject',
  test: 'test',
  next: 'Next step',
  start: 'enable',
  start1: 'Enable automatic refresh',
  stop: 'deactivate',
  stop1: 'Disable automatic refresh',
  submit: 'submit',
  recharge: 'top up',
  transfer: 'Wallet transfer',
  callback: 'callback'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/sysConfig.js